/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AccountRouteImport } from './routes/account'
import { Route as BranchesRouteImport } from './routes/branches'
import { Route as CartRouteImport } from './routes/cart'
import { Route as CheckoutRouteImport } from './routes/checkout'
import { Route as LoginRouteImport } from './routes/login'
import { Route as LoyaltyRouteImport } from './routes/loyalty'
import { Route as MainMenuRouteImport } from './routes/main-menu'
import { Route as OrderSuccessRouteImport } from './routes/order-success'
import { Route as OrderTypeRouteImport } from './routes/order-type'
import { Route as PaymentReturnRouteImport } from './routes/payment-return'
import { Route as PreviewRouteImport } from './routes/preview'
import { Route as PrivacyPolicyRouteImport } from './routes/privacy-policy'
import { Route as ReturnPolicyRouteImport } from './routes/return-policy'
import { Route as TermsAndConditionsRouteImport } from './routes/terms-and-conditions'
import { Route as BranchMenuIndexRouteImport } from './routes/branchMenu.index'
import { Route as BranchMenuBranchIdRouteImport } from './routes/branchMenu.$branchId'
import { Route as BranchesBranchIdRouteImport } from './routes/branches_.$branchId'
import { Route as MenuIndexRouteImport } from './routes/menu.index'
import { Route as MenuSlugRouteImport } from './routes/menu.$slug'
import { Route as OTokenRouteImport } from './routes/o.$token'
import { Route as OrdersIndexRouteImport } from './routes/orders.index'
import { Route as OrdersOrderIdRouteImport } from './routes/orders.$orderId'
import { Route as PayTokenRouteImport } from './routes/pay.$token'
import { Route as BranchesBranchIdMenuRouteImport } from './routes/branches_.$branchId_.menu'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AccountRoute = AccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => rootRouteImport,
} as any)
const BranchesRoute = BranchesRouteImport.update({
  id: '/branches',
  path: '/branches',
  getParentRoute: () => rootRouteImport,
} as any)
const CartRoute = CartRouteImport.update({
  id: '/cart',
  path: '/cart',
  getParentRoute: () => rootRouteImport,
} as any)
const CheckoutRoute = CheckoutRouteImport.update({
  id: '/checkout',
  path: '/checkout',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const LoyaltyRoute = LoyaltyRouteImport.update({
  id: '/loyalty',
  path: '/loyalty',
  getParentRoute: () => rootRouteImport,
} as any)
const MainMenuRoute = MainMenuRouteImport.update({
  id: '/main-menu',
  path: '/main-menu',
  getParentRoute: () => rootRouteImport,
} as any)
const OrderSuccessRoute = OrderSuccessRouteImport.update({
  id: '/order-success',
  path: '/order-success',
  getParentRoute: () => rootRouteImport,
} as any)
const OrderTypeRoute = OrderTypeRouteImport.update({
  id: '/order-type',
  path: '/order-type',
  getParentRoute: () => rootRouteImport,
} as any)
const PaymentReturnRoute = PaymentReturnRouteImport.update({
  id: '/payment-return',
  path: '/payment-return',
  getParentRoute: () => rootRouteImport,
} as any)
const PreviewRoute = PreviewRouteImport.update({
  id: '/preview',
  path: '/preview',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyPolicyRoute = PrivacyPolicyRouteImport.update({
  id: '/privacy-policy',
  path: '/privacy-policy',
  getParentRoute: () => rootRouteImport,
} as any)
const ReturnPolicyRoute = ReturnPolicyRouteImport.update({
  id: '/return-policy',
  path: '/return-policy',
  getParentRoute: () => rootRouteImport,
} as any)
const TermsAndConditionsRoute = TermsAndConditionsRouteImport.update({
  id: '/terms-and-conditions',
  path: '/terms-and-conditions',
  getParentRoute: () => rootRouteImport,
} as any)
const BranchMenuIndexRoute = BranchMenuIndexRouteImport.update({
  id: '/branchMenu/',
  path: '/branchMenu/',
  getParentRoute: () => rootRouteImport,
} as any)
const BranchMenuBranchIdRoute = BranchMenuBranchIdRouteImport.update({
  id: '/branchMenu/$branchId',
  path: '/branchMenu/$branchId',
  getParentRoute: () => rootRouteImport,
} as any)
const BranchesBranchIdRoute = BranchesBranchIdRouteImport.update({
  id: '/branches_/$branchId',
  path: '/branches/$branchId',
  getParentRoute: () => rootRouteImport,
} as any)
const MenuIndexRoute = MenuIndexRouteImport.update({
  id: '/menu/',
  path: '/menu/',
  getParentRoute: () => rootRouteImport,
} as any)
const MenuSlugRoute = MenuSlugRouteImport.update({
  id: '/menu/$slug',
  path: '/menu/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const OTokenRoute = OTokenRouteImport.update({
  id: '/o/$token',
  path: '/o/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const OrdersIndexRoute = OrdersIndexRouteImport.update({
  id: '/orders/',
  path: '/orders/',
  getParentRoute: () => rootRouteImport,
} as any)
const OrdersOrderIdRoute = OrdersOrderIdRouteImport.update({
  id: '/orders/$orderId',
  path: '/orders/$orderId',
  getParentRoute: () => rootRouteImport,
} as any)
const PayTokenRoute = PayTokenRouteImport.update({
  id: '/pay/$token',
  path: '/pay/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const BranchesBranchIdMenuRoute = BranchesBranchIdMenuRouteImport.update({
  id: '/branches_/$branchId_/menu',
  path: '/branches/$branchId/menu',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/account': typeof AccountRoute
  '/branches': typeof BranchesRoute
  '/cart': typeof CartRoute
  '/checkout': typeof CheckoutRoute
  '/login': typeof LoginRoute
  '/loyalty': typeof LoyaltyRoute
  '/main-menu': typeof MainMenuRoute
  '/order-success': typeof OrderSuccessRoute
  '/order-type': typeof OrderTypeRoute
  '/payment-return': typeof PaymentReturnRoute
  '/preview': typeof PreviewRoute
  '/privacy-policy': typeof PrivacyPolicyRoute
  '/return-policy': typeof ReturnPolicyRoute
  '/terms-and-conditions': typeof TermsAndConditionsRoute
  '/branchMenu/$branchId': typeof BranchMenuBranchIdRoute
  '/branches/$branchId': typeof BranchesBranchIdRoute
  '/menu/$slug': typeof MenuSlugRoute
  '/o/$token': typeof OTokenRoute
  '/orders/$orderId': typeof OrdersOrderIdRoute
  '/pay/$token': typeof PayTokenRoute
  '/branchMenu/': typeof BranchMenuIndexRoute
  '/menu/': typeof MenuIndexRoute
  '/orders/': typeof OrdersIndexRoute
  '/branches/$branchId/menu': typeof BranchesBranchIdMenuRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/account': typeof AccountRoute
  '/branches': typeof BranchesRoute
  '/cart': typeof CartRoute
  '/checkout': typeof CheckoutRoute
  '/login': typeof LoginRoute
  '/loyalty': typeof LoyaltyRoute
  '/main-menu': typeof MainMenuRoute
  '/order-success': typeof OrderSuccessRoute
  '/order-type': typeof OrderTypeRoute
  '/payment-return': typeof PaymentReturnRoute
  '/preview': typeof PreviewRoute
  '/privacy-policy': typeof PrivacyPolicyRoute
  '/return-policy': typeof ReturnPolicyRoute
  '/terms-and-conditions': typeof TermsAndConditionsRoute
  '/branchMenu/$branchId': typeof BranchMenuBranchIdRoute
  '/branches/$branchId': typeof BranchesBranchIdRoute
  '/menu/$slug': typeof MenuSlugRoute
  '/o/$token': typeof OTokenRoute
  '/orders/$orderId': typeof OrdersOrderIdRoute
  '/pay/$token': typeof PayTokenRoute
  '/branchMenu': typeof BranchMenuIndexRoute
  '/menu': typeof MenuIndexRoute
  '/orders': typeof OrdersIndexRoute
  '/branches/$branchId/menu': typeof BranchesBranchIdMenuRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/account': typeof AccountRoute
  '/branches': typeof BranchesRoute
  '/cart': typeof CartRoute
  '/checkout': typeof CheckoutRoute
  '/login': typeof LoginRoute
  '/loyalty': typeof LoyaltyRoute
  '/main-menu': typeof MainMenuRoute
  '/order-success': typeof OrderSuccessRoute
  '/order-type': typeof OrderTypeRoute
  '/payment-return': typeof PaymentReturnRoute
  '/preview': typeof PreviewRoute
  '/privacy-policy': typeof PrivacyPolicyRoute
  '/return-policy': typeof ReturnPolicyRoute
  '/terms-and-conditions': typeof TermsAndConditionsRoute
  '/branchMenu/$branchId': typeof BranchMenuBranchIdRoute
  '/branches_/$branchId': typeof BranchesBranchIdRoute
  '/menu/$slug': typeof MenuSlugRoute
  '/o/$token': typeof OTokenRoute
  '/orders/$orderId': typeof OrdersOrderIdRoute
  '/pay/$token': typeof PayTokenRoute
  '/branchMenu/': typeof BranchMenuIndexRoute
  '/menu/': typeof MenuIndexRoute
  '/orders/': typeof OrdersIndexRoute
  '/branches_/$branchId_/menu': typeof BranchesBranchIdMenuRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/account'
    | '/branches'
    | '/cart'
    | '/checkout'
    | '/login'
    | '/loyalty'
    | '/main-menu'
    | '/order-success'
    | '/order-type'
    | '/payment-return'
    | '/preview'
    | '/privacy-policy'
    | '/return-policy'
    | '/terms-and-conditions'
    | '/branchMenu/$branchId'
    | '/branches/$branchId'
    | '/menu/$slug'
    | '/o/$token'
    | '/orders/$orderId'
    | '/pay/$token'
    | '/branchMenu/'
    | '/menu/'
    | '/orders/'
    | '/branches/$branchId/menu'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/account'
    | '/branches'
    | '/cart'
    | '/checkout'
    | '/login'
    | '/loyalty'
    | '/main-menu'
    | '/order-success'
    | '/order-type'
    | '/payment-return'
    | '/preview'
    | '/privacy-policy'
    | '/return-policy'
    | '/terms-and-conditions'
    | '/branchMenu/$branchId'
    | '/branches/$branchId'
    | '/menu/$slug'
    | '/o/$token'
    | '/orders/$orderId'
    | '/pay/$token'
    | '/branchMenu'
    | '/menu'
    | '/orders'
    | '/branches/$branchId/menu'
  id:
    | '__root__'
    | '/'
    | '/account'
    | '/branches'
    | '/cart'
    | '/checkout'
    | '/login'
    | '/loyalty'
    | '/main-menu'
    | '/order-success'
    | '/order-type'
    | '/payment-return'
    | '/preview'
    | '/privacy-policy'
    | '/return-policy'
    | '/terms-and-conditions'
    | '/branchMenu/$branchId'
    | '/branches_/$branchId'
    | '/menu/$slug'
    | '/o/$token'
    | '/orders/$orderId'
    | '/pay/$token'
    | '/branchMenu/'
    | '/menu/'
    | '/orders/'
    | '/branches_/$branchId_/menu'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AccountRoute: typeof AccountRoute
  BranchesRoute: typeof BranchesRoute
  CartRoute: typeof CartRoute
  CheckoutRoute: typeof CheckoutRoute
  LoginRoute: typeof LoginRoute
  LoyaltyRoute: typeof LoyaltyRoute
  MainMenuRoute: typeof MainMenuRoute
  OrderSuccessRoute: typeof OrderSuccessRoute
  OrderTypeRoute: typeof OrderTypeRoute
  PaymentReturnRoute: typeof PaymentReturnRoute
  PreviewRoute: typeof PreviewRoute
  PrivacyPolicyRoute: typeof PrivacyPolicyRoute
  ReturnPolicyRoute: typeof ReturnPolicyRoute
  TermsAndConditionsRoute: typeof TermsAndConditionsRoute
  BranchMenuBranchIdRoute: typeof BranchMenuBranchIdRoute
  BranchesBranchIdRoute: typeof BranchesBranchIdRoute
  MenuSlugRoute: typeof MenuSlugRoute
  OTokenRoute: typeof OTokenRoute
  OrdersOrderIdRoute: typeof OrdersOrderIdRoute
  PayTokenRoute: typeof PayTokenRoute
  BranchMenuIndexRoute: typeof BranchMenuIndexRoute
  MenuIndexRoute: typeof MenuIndexRoute
  OrdersIndexRoute: typeof OrdersIndexRoute
  BranchesBranchIdMenuRoute: typeof BranchesBranchIdMenuRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/account': {
      id: '/account'
      path: '/account'
      fullPath: '/account'
      preLoaderRoute: typeof AccountRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/branches': {
      id: '/branches'
      path: '/branches'
      fullPath: '/branches'
      preLoaderRoute: typeof BranchesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cart': {
      id: '/cart'
      path: '/cart'
      fullPath: '/cart'
      preLoaderRoute: typeof CartRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/checkout': {
      id: '/checkout'
      path: '/checkout'
      fullPath: '/checkout'
      preLoaderRoute: typeof CheckoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/loyalty': {
      id: '/loyalty'
      path: '/loyalty'
      fullPath: '/loyalty'
      preLoaderRoute: typeof LoyaltyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/main-menu': {
      id: '/main-menu'
      path: '/main-menu'
      fullPath: '/main-menu'
      preLoaderRoute: typeof MainMenuRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/order-success': {
      id: '/order-success'
      path: '/order-success'
      fullPath: '/order-success'
      preLoaderRoute: typeof OrderSuccessRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/order-type': {
      id: '/order-type'
      path: '/order-type'
      fullPath: '/order-type'
      preLoaderRoute: typeof OrderTypeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/payment-return': {
      id: '/payment-return'
      path: '/payment-return'
      fullPath: '/payment-return'
      preLoaderRoute: typeof PaymentReturnRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/preview': {
      id: '/preview'
      path: '/preview'
      fullPath: '/preview'
      preLoaderRoute: typeof PreviewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy-policy': {
      id: '/privacy-policy'
      path: '/privacy-policy'
      fullPath: '/privacy-policy'
      preLoaderRoute: typeof PrivacyPolicyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/return-policy': {
      id: '/return-policy'
      path: '/return-policy'
      fullPath: '/return-policy'
      preLoaderRoute: typeof ReturnPolicyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/terms-and-conditions': {
      id: '/terms-and-conditions'
      path: '/terms-and-conditions'
      fullPath: '/terms-and-conditions'
      preLoaderRoute: typeof TermsAndConditionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/branchMenu/': {
      id: '/branchMenu/'
      path: '/branchMenu'
      fullPath: '/branchMenu/'
      preLoaderRoute: typeof BranchMenuIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/branchMenu/$branchId': {
      id: '/branchMenu/$branchId'
      path: '/branchMenu/$branchId'
      fullPath: '/branchMenu/$branchId'
      preLoaderRoute: typeof BranchMenuBranchIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/branches_/$branchId': {
      id: '/branches_/$branchId'
      path: '/branches/$branchId'
      fullPath: '/branches/$branchId'
      preLoaderRoute: typeof BranchesBranchIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/menu/': {
      id: '/menu/'
      path: '/menu'
      fullPath: '/menu/'
      preLoaderRoute: typeof MenuIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/menu/$slug': {
      id: '/menu/$slug'
      path: '/menu/$slug'
      fullPath: '/menu/$slug'
      preLoaderRoute: typeof MenuSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/o/$token': {
      id: '/o/$token'
      path: '/o/$token'
      fullPath: '/o/$token'
      preLoaderRoute: typeof OTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/orders/': {
      id: '/orders/'
      path: '/orders'
      fullPath: '/orders/'
      preLoaderRoute: typeof OrdersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/orders/$orderId': {
      id: '/orders/$orderId'
      path: '/orders/$orderId'
      fullPath: '/orders/$orderId'
      preLoaderRoute: typeof OrdersOrderIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pay/$token': {
      id: '/pay/$token'
      path: '/pay/$token'
      fullPath: '/pay/$token'
      preLoaderRoute: typeof PayTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/branches_/$branchId_/menu': {
      id: '/branches_/$branchId_/menu'
      path: '/branches/$branchId/menu'
      fullPath: '/branches/$branchId/menu'
      preLoaderRoute: typeof BranchesBranchIdMenuRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AccountRoute: AccountRoute,
  BranchesRoute: BranchesRoute,
  CartRoute: CartRoute,
  CheckoutRoute: CheckoutRoute,
  LoginRoute: LoginRoute,
  LoyaltyRoute: LoyaltyRoute,
  MainMenuRoute: MainMenuRoute,
  OrderSuccessRoute: OrderSuccessRoute,
  OrderTypeRoute: OrderTypeRoute,
  PaymentReturnRoute: PaymentReturnRoute,
  PreviewRoute: PreviewRoute,
  PrivacyPolicyRoute: PrivacyPolicyRoute,
  ReturnPolicyRoute: ReturnPolicyRoute,
  TermsAndConditionsRoute: TermsAndConditionsRoute,
  BranchMenuBranchIdRoute: BranchMenuBranchIdRoute,
  BranchesBranchIdRoute: BranchesBranchIdRoute,
  MenuSlugRoute: MenuSlugRoute,
  OTokenRoute: OTokenRoute,
  OrdersOrderIdRoute: OrdersOrderIdRoute,
  PayTokenRoute: PayTokenRoute,
  BranchMenuIndexRoute: BranchMenuIndexRoute,
  MenuIndexRoute: MenuIndexRoute,
  OrdersIndexRoute: OrdersIndexRoute,
  BranchesBranchIdMenuRoute: BranchesBranchIdMenuRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
